import * as types from "../../constants/conference/conference_constants";

const initialState = {
  data: null,
  variety: null,
  conferenceError: null,
  product: null,
  exempt: null,
  message: null,
  search: null,
  manual: null,
  genre: null,
  approve: null,
};

const conferenceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_CONFERENCE_SUCCESS:
    case types.UPDATE_CONFERENCE_SUCCESS:
    case types.ADD_CONFERENCE_SUCCESS:
    case types.DELETE_CONFERENCE_SUCCESS:
      return {
        ...state,
        data: payload ? payload.conference : null,
        conferenceError: null,
      };

    case types.CONFERENCE_TRANSPORTATION_SUCCESS:
    case types.CONFERENCE_CRECHE_SUCCESS:
      return {
        ...state,
        data: payload ? payload.items : null,
        conferenceError: null,
      };

    case types.CONFERENCE_PAID_SUCCESS:
    case types.CONFERENCE_REGISTER_SUCCESS:
    case types.CONFERENCE_NEEDS_SUCCESS:
      return {
        ...state,
        variety: payload ? payload.list : null,
        conferenceError: null,
      };

    case types.DELETE_PART_SUCCESS:
      return {
        ...state,
        message: payload ? payload.message : null,
        conferenceError: null,
      };

    case types.GET_CONFERENCE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        data: payload ? payload.conference : null,
        product: payload ? payload.product : null,
        conferenceError: null,
      };

    case types.MANUAL_CONFERENCE_SUCCESS:
    case types.CONFERENCE_MANUAL_DELETE_SUCCESS:
      return {
        ...state,
        message: payload ? payload.message : null,
        conferenceError: null,
      };

    case types.CONFERENCE_FILTER_SUCCESS:
    case types.SEARCH_CONFERENCE_EXEMPT_SUCCESS:
    case types.CONFERENCE_MISC_FILTER_SUCCESS:
    case types.CONFERENCE_NEEDS_FILTER_SUCCESS:
      return {
        ...state,
        search: payload ? payload.search : null,
        conferenceError: null,
      };

    case types.ADD_CONFERENCE_EXEMPT_SUCCESS:
    case types.DELETE_CONFERENCE_EXEMPT_SUCCESS:
    case types.GET_CONFERENCE_EXEMPT_SUCCESS:
      return {
        ...state,
        exempt: payload ? payload.exempt : null,
        conferenceError: null,
      };

    case types.CONFERENCE_MANUAL_AUTHORIZATION_ADD_SUCCESS:
    case types.CONFERENCE_MANUAL_AUTHORIZATION_LIST_SUCCESS:
      return {
        ...state,
        manual: payload ? payload.manual : null,
        conferenceError: null,
        genre: payload ? payload.genre : null,
      };

    case types.CONFERENCE_MANUAL_APPROVE_SUCCESS:
      return {
        ...state,
        approve: payload ? payload.data : null,
        conferenceError: null,
      };

    case types.GET_CONFERENCE_FAILURE:
    case types.ADD_CONFERENCE_FAILURE:
    case types.UPDATE_CONFERENCE_FAILURE:
    case types.DELETE_CONFERENCE_FAILURE:
    case types.GET_CONFERENCE_PARTICIPANT_FAILURE:
    case types.MANUAL_CONFERENCE_FAILURE:
    case types.CONFERENCE_PAID_FAILURE:
    case types.CONFERENCE_REGISTER_FAILURE:
    case types.CONFERENCE_NEEDS_FAILURE:
    case types.DELETE_PART_FAILURE:
    case types.CONFERENCE_FILTER_FAILURE:
    case types.CONFERENCE_MANUAL_DELETE_FAILURE:
    case types.CONFERENCE_CRECHE_FAILURE:
    case types.CONFERENCE_TRANSPORTATION_FAILURE:
    case types.CONFERENCE_MANUAL_APPROVE_FAILURE:
    case types.CONFERENCE_MISC_FILTER_FAILURE:
    case types.CONFERENCE_NEEDS_FILTER_FAILURE:
      return { ...state, conferenceError: payload ? payload : null };

    case types.ADD_CONFERENCE_EXEMPT_FAILURE:
    case types.DELETE_CONFERENCE_EXEMPT_FAILURE:
    case types.GET_CONFERENCE_EXEMPT_FAILURE:
    case types.CONFERENCE_MANUAL_AUTHORIZATION_ADD_FAILURE:
    case types.CONFERENCE_MANUAL_AUTHORIZATION_LIST_FAILURE:
    case types.SEARCH_CONFERENCE_EXEMPT_FAILURE:
      return { ...state, conferenceError: payload ? payload : null };

    default:
      return state;
  }
};

export default conferenceReducer;
